<template lang="pug">
div
  app-listagem-processo-analisados
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FILTRO_EMPTY from '@/models/filtro'
import AppListagemProcessoAnalisados from '../../relatorios/components/gerais/AppListagemProcessoAnalisados.vue'

export default {
  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagemProcessoAnalisados
  },

  data () {
    return {
      filtro: FILTRO_EMPTY('PROCESSOS_ANALISADOS'),
      items: [],
      totalElements: 0,
      usuario: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  computed: {
    ...mapActions({
      findProcessosByFilter: 'dashboardRelatorios/findProcessosByFilter'
    }),
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/ProcessosAnalisadosListagem.vue